import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Message, Card, Button } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './main.scss'
import './registerServiceWorker'
import reveal from './directives/reveal'

Vue.config.productionTip = false

// Element UI：提示 + 版本更新卡片
Vue.prototype.$message = Message
Vue.use(Card)
Vue.use(Button)

// 滚动进入视口淡入动画
Vue.directive('reveal', reveal)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
